export default "__VITE_ASSET__BxEuZkgy__"